import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import WhatWeDo from "@/pages/WhatWeDo";
import AriseEcho from "@/pages/AriseEcho";
import HowWeWork from "@/pages/HowWeWork";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CompanyInformation from "@/pages/CompanyInformation";
import { APPLYKAR_URL } from "@/lib/constants";
import Hiring from "@/pages/Hiring";
import Insights from "@/pages/Insights";
import Consultation from "@/pages/Consultation";
import TalentTraining from "@/pages/TalentTraining";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import useAnalytics from "@/hooks/useAnalytics";
import { Toaster } from "sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Full-page redirect for legacy routes that now live on an external site.
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

const AnalyticsTracker = () => {
  useAnalytics();
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/hiring" element={<Hiring />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/arise-and-echo" element={<AriseEcho />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/company-information" element={<CompanyInformation />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/talent-training" element={<TalentTraining />} />
            {/* Legacy routes from the founder-led site, redirected to their v2 equivalents */}
            <Route path="/services" element={<Navigate to="/what-we-do" replace />} />
            <Route path="/website-software" element={<Navigate to="/what-we-do" replace />} />
            <Route path="/social-media-management" element={<Navigate to="/arise-and-echo" replace />} />
            <Route path="/hiring-hr" element={<Navigate to="/hiring" replace />} />
            <Route path="/founder" element={<Navigate to="/about" replace />} />
            <Route path="/careers" element={<Navigate to="/talent-training" replace />} />
            <Route path="/apply" element={<Navigate to="/consultation" replace />} />
            {/* Unknown paths fall back to Home */}
            <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
